import { createAction } from '@reduxjs/toolkit';

export const setTopSearchTerm = createAction<string>('top-search/set-term');
export const setTopSearchLoading = createAction<boolean>(
    'top-search/set-loading',
);
